<template>
	<section class="app" >
		<div class="copy" v-html="copy"></div>
		<div class="image">
			<img v-if="image" :src="image.url" :alt="image.alt" />
		</div>
		<div class="shop">
			<a v-if="google" :href="google" target="_blank" @mouseenter="onPointerMouseEnter($event, 'top2')" @mouseleave="onPointerMouseLeave($event, 'top2')">
				<IconGoogle />
			</a>
			<a v-if="apple" :href="apple" target="_blank" @mouseenter="onPointerMouseEnter($event, 'top2')" @mouseleave="onPointerMouseLeave($event, 'top2')">
				<IconApple />
			</a>
		</div>
	</section>
</template>

<script>
import IconApple from '@/components/icons/IconApple';
import IconGoogle from '@/components/icons/IconGoogle';
import pointerHove from '@/mixins/pointerHover';

export default {
	mixins: [pointerHove],
	props: {
		copy: [Boolean,String],
		image: [Boolean,Object],
		google: [Boolean,String],
		apple: [Boolean,String]
	},
	components: {
		IconApple,
		IconGoogle
	}
}
</script>

<style lang="scss" scoped>
.app {
	width: 100% !important;
	display: flex;
	flex-wrap: wrap;
	margin-left: 0 !important;
	margin-top: 40px;

	@include mq($from: m) {
		margin-top: 50px;
	}

	@include mq($from: xl) {
		margin-top: 160px;
		margin-bottom: 80px;
		margin-left: 4.25199%;
	}

	.copy {
		@include fontCopy;
		@include textFormat;


		@include mq($to: m) {
			margin-bottom: 40px;
		}

		@include mq($from: m) {
			@include gridColumn(m, 11, 1, false, false);
		}

		@include mq($from: xl) {
			@include gridColumn(xl, 7, 2, false, false);
		}

		&::v-deep h1 {
			@include fontH0;

			@include mq($from: m) {
				margin-top: 0;
			}
		}
	}

	.image {
		@include gridColumn(s, 6, 0, false, false);

		@include mq($from: m) {
			@include gridColumn(m, 6, 1, false, false);
		}

		@include mq($from: xl) {
			@include gridColumn(xl, 4, 1, false, false);
		}

		img {
			display: block;
			max-width: 100%;
		}
	}

	.shop {
		@include gridColumn(s, 5, 1, false, true);

		@include mq($from: m) {
			@include gridColumn(m, 4, 1, false, true);
		}

		@include mq($from: xl) {
			@include gridColumn(xl, 3, 1, false, true);
		}

		a {
			display: block;
			margin-top: 20px;

			&:first-child {
				margin-top: 0;
			}
		}

		svg {
			width: 100%;
			height: auto;
		}
	}
}

</style>